var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "4a239148b2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.332031 2.347656 L 278 2.347656 L 278 280 L 1.332031 280 Z M 1.332031 2.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1f1e61e0c7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 186.050781 2.304688 C 91.648438 2.304688 97.539062 43.300781 97.539062 43.300781 L 97.644531 85.769531 L 187.722656 85.769531 L 187.722656 98.523438 L 61.867188 98.523438 C 61.867188 98.523438 1.460938 91.660156 1.460938 187.042969 C 1.460938 282.429688 54.183594 279.046875 54.183594 279.046875 L 85.648438 279.046875 L 85.648438 234.78125 C 85.648438 234.78125 83.953125 181.984375 137.53125 181.984375 L 226.875 181.984375 C 226.875 181.984375 277.066406 182.800781 277.066406 133.402344 L 277.066406 51.730469 C 277.066406 51.730469 284.695312 2.304688 186.050781 2.304688 Z M 136.371094 30.863281 C 145.335938 30.863281 152.574219 38.117188 152.574219 47.09375 C 152.574219 56.070312 145.335938 63.324219 136.371094 63.324219 C 127.410156 63.324219 120.164062 56.070312 120.164062 47.09375 C 120.164062 38.117188 127.410156 30.863281 136.371094 30.863281 Z M 136.371094 30.863281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.00416843,
    gradientTransform: "matrix(275.739463, 0, 0, 276.756923, 1.462218, 2.30527)",
    y1: -0.00405722,
    x2: 1.027758,
    gradientUnits: "userSpaceOnUse",
    y2: 1.01158,
    id: "0dbd4b540b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.998596%, 49.398804%, 72.198486%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.99707%, 49.383545%, 72.171021%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.986389%, 49.269104%, 71.974182%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.966553%, 49.072266%, 71.633911%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.948242%, 48.875427%, 71.29364%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.928406%, 48.678589%, 70.953369%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.910095%, 48.48175%, 70.611572%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.890259%, 48.286438%, 70.271301%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.870422%, 48.0896%, 69.93103%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.852112%, 47.892761%, 69.590759%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.832275%, 47.695923%, 69.250488%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.813965%, 47.499084%, 68.908691%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.794128%, 47.302246%, 68.56842%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.775818%, 47.105408%, 68.228149%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.755981%, 46.908569%, 67.887878%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.736145%, 46.711731%, 67.546082%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.717834%, 46.514893%, 67.205811%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.697998%, 46.31958%, 66.86554%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.679688%, 46.122742%, 66.525269%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.659851%, 45.925903%, 66.184998%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.641541%, 45.729065%, 65.843201%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.621704%, 45.532227%, 65.50293%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.601868%, 45.335388%, 65.162659%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.583557%, 45.13855%, 64.822388%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.563721%, 44.941711%, 64.482117%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.54541%, 44.744873%, 64.14032%)",
    offset: 0.494335
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.536255%, 44.647217%, 63.970947%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.525574%, 44.548035%, 63.800049%)",
    offset: 0.505665
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.516418%, 44.450378%, 63.630676%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.505737%, 44.352722%, 63.459778%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.487427%, 44.155884%, 63.119507%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.46759%, 43.959045%, 62.77771%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.44928%, 43.762207%, 62.437439%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.429443%, 43.565369%, 62.097168%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.411133%, 43.36853%, 61.756897%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.391296%, 43.171692%, 61.416626%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.37146%, 42.974854%, 61.074829%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.353149%, 42.778015%, 60.734558%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.333313%, 42.582703%, 60.394287%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.315002%, 42.385864%, 60.054016%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.295166%, 42.189026%, 59.713745%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.276855%, 41.992188%, 59.371948%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.257019%, 41.795349%, 59.031677%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.237183%, 41.598511%, 58.691406%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.218872%, 41.401672%, 58.351135%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.203613%, 41.25061%, 58.09021%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 41.19873%, 57.998657%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 41.19873%, 57.998657%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.199036%, 41.19873%, 57.998657%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4c9c936c50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 97 95 L 373.332031 95 L 373.332031 372.847656 L 97 372.847656 Z M 97 95 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a3c76cc466"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 188.726562 372.742188 C 283.121094 372.742188 277.226562 331.742188 277.226562 331.742188 L 277.121094 289.269531 L 187.039062 289.269531 L 187.039062 276.523438 L 312.898438 276.523438 C 312.898438 276.523438 373.308594 283.378906 373.308594 188.003906 C 373.308594 92.617188 320.585938 96 320.585938 96 L 289.121094 96 L 289.121094 140.261719 C 289.121094 140.261719 290.808594 193.0625 237.242188 193.0625 L 147.886719 193.0625 C 147.886719 193.0625 97.695312 192.246094 97.695312 241.648438 L 97.695312 323.316406 C 97.695312 323.316406 90.074219 372.742188 188.726562 372.742188 Z M 238.394531 344.179688 C 229.4375 344.179688 222.1875 336.917969 222.1875 327.953125 C 222.1875 318.96875 229.4375 311.722656 238.394531 311.722656 C 247.363281 311.722656 254.597656 318.96875 254.597656 327.953125 C 254.597656 336.917969 247.363281 344.179688 238.394531 344.179688 Z M 238.394531 344.179688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -0.0326453,
    gradientTransform: "matrix(275.747823, 0, 0, 276.758323, 97.559794, 95.985318)",
    y1: -0.00636588,
    x2: 1.013978,
    gradientUnits: "userSpaceOnUse",
    y2: 0.985247,
    id: "6d778164c2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 87.799072%, 32.199097%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 87.799072%, 32.199097%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 87.799072%, 32.199097%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 87.759399%, 32.15332%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 87.590027%, 31.959534%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 87.332153%, 31.661987%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 87.07428%, 31.365967%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 86.816406%, 31.06842%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 86.558533%, 30.7724%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 86.300659%, 30.474854%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 86.04126%, 30.177307%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 85.783386%, 29.881287%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 85.525513%, 29.58374%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 85.267639%, 29.28772%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 85.009766%, 28.990173%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 84.751892%, 28.694153%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 84.494019%, 28.396606%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 84.236145%, 28.100586%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 83.978271%, 27.80304%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 83.720398%, 27.505493%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 83.460999%, 27.209473%)",
    offset: 0.482837
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 83.332825%, 27.061462%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 83.203125%, 26.911926%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 82.945251%, 26.615906%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 82.687378%, 26.318359%)",
    offset: 0.517163
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 82.559204%, 26.170349%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 82.429504%, 26.022339%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 82.171631%, 25.724792%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 81.913757%, 25.428772%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 81.655884%, 25.131226%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 81.39801%, 24.835205%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 81.138611%, 24.537659%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 80.880737%, 24.240112%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 80.622864%, 23.944092%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 80.36499%, 23.646545%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 80.107117%, 23.350525%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 79.849243%, 23.052979%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 79.59137%, 22.756958%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 79.333496%, 22.459412%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 79.075623%, 22.163391%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 78.816223%, 21.865845%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 78.55835%, 21.568298%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 78.300476%, 21.272278%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 78.042603%, 20.974731%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 77.784729%, 20.678711%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 77.526855%, 20.381165%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 77.268982%, 20.085144%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 77.011108%, 19.787598%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 76.753235%, 19.491577%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 76.560974%, 19.270325%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 76.499939%, 19.198608%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 76.499939%, 19.198608%)",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4a239148b2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1f1e61e0c7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#0dbd4b540b)",
    d: "M 1.460938 2.347656 L 1.460938 282.429688 L 284.695312 282.429688 L 284.695312 2.347656 Z M 1.460938 2.347656 ",
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4c9c936c50)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a3c76cc466)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#6d778164c2)",
    d: "M 90.074219 92.617188 L 90.074219 372.742188 L 373.308594 372.742188 L 373.308594 92.617188 Z M 90.074219 92.617188 ",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.732ffa954adf3bc16ee6d9d66c5ec616.svg";
export { ForwardRef as ReactComponent };